import { useAuthContext } from '../../context/AuthContext';
import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';

const navItems = [
  { to: '/system-admin', label: 'ダッシュボード', end: true },
  { to: '/system-admin/category', label: 'カテゴリ', end: false },
  { to: '/system-admin/item', label: '商品マスタ', end: false },
  { to: '/system-admin/store', label: '店舗一覧', end: false },
  { to: '/system-admin/store-inquiry', label: '店舗掲載リクエスト', end: false },
] as const;

interface SystemAdminSidebarProps {
  onNavigate?: () => void;
}

const SystemAdminSidebar = ({ onNavigate }: SystemAdminSidebarProps) => {
  const navigate = useNavigate();
  const { logout } = useAuthContext();

  const inactiveNavLinkClass =
    'block no-underline py-2.5 px-4 rounded-xl transition-all duration-200 text-stone-600 hover:text-stone-800 hover:bg-white/80 hover:shadow-sm';

  const navLinkClass = ({ isActive }: { isActive: boolean }) =>
    [
      'block no-underline py-2.5 px-4 rounded-xl transition-all duration-200',
      isActive
        ? 'bg-teal-500 text-white shadow-sm font-medium'
        : 'text-stone-600 hover:text-stone-800 hover:bg-white/80 hover:shadow-sm',
    ].join(' ');

  const handleLogout = () => {
    if (!window.confirm('ログアウトしますか？')) {
      return;
    }

    logout();
    navigate('/login');
    onNavigate?.();
  };

  return (
    <aside className="flex h-full flex-col border-r border-stone-200/80 bg-stone-100/90 py-6 text-stone-800 sm:py-8">
      <h1 className="mb-6 px-4 text-center text-lg font-medium text-stone-700 sm:mb-8">
        システム管理メニュー
      </h1>
      <nav className="w-full px-3">
        <ul className="m-0 list-none space-y-1 p-0">
          {navItems.map((item) => (
            <li key={item.to}>
              <NavLink to={item.to} end={item.end} className={navLinkClass} onClick={onNavigate}>
                {item.label}
              </NavLink>
            </li>
          ))}
          <li>
            <button type="button" className={`${inactiveNavLinkClass} w-full text-left`} onClick={handleLogout}>
              ログアウト
            </button>
          </li>
        </ul>
      </nav>
    </aside>
  );
};

export default SystemAdminSidebar;
